<template>
  <transition name="slide-up">
    <div
      v-if="visible"
      class="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 rounded-2xl border border-slate-200 bg-white px-4 py-3 shadow-xl max-w-sm w-[calc(100%-2rem)]"
      role="alertdialog"
      aria-live="polite"
    >
      <span class="text-xl">🇵🇱</span>
      <p class="flex-1 text-xs text-slate-700 font-medium leading-snug">
        Wygląda na to, że jesteś z Polski. Czy chcesz przeglądać w języku polskim?
      </p>
      <div class="flex items-center gap-2 flex-shrink-0">
        <button
          @click="accept"
          class="rounded-lg bg-blue-600 px-3 py-1.5 text-xs font-bold text-white hover:bg-blue-700 transition-colors"
        >
          Tak
        </button>
        <button
          @click="dismiss"
          class="rounded-lg bg-slate-100 px-3 py-1.5 text-xs font-bold text-slate-600 hover:bg-slate-200 transition-colors"
          aria-label="Dismiss"
        >
          ✕
        </button>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'

const STORAGE_KEY = 'pfLocaleBannerDismissed'

const router = useRouter()
const route  = useRoute()
const { locale } = useI18n()

const visible = ref(false)

function dismiss() {
  visible.value = false
  try { localStorage.setItem(STORAGE_KEY, '1') } catch (_) { /* storage unavailable */ }
}

function accept() {
  dismiss()
  const currentPath = route.fullPath
  const withoutLocale = currentPath.replace(/^\/pl(\/|$)/, (_, sep) => sep || '/')
  const newPath = '/pl' + (withoutLocale === '/' ? '' : withoutLocale)
  router.push(newPath)
}

onMounted(() => {
  try {
    const alreadyDismissed = localStorage.getItem(STORAGE_KEY)
    const savedLocale      = localStorage.getItem('pfLocale')
    if (alreadyDismissed || savedLocale === 'pl' || locale.value === 'pl') return

    const browserLang = (navigator.language || '').toLowerCase()
    if (browserLang.startsWith('pl')) {
      visible.value = true
    }
  } catch (_) { /* storage unavailable */ }
})
</script>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.slide-up-enter-from,
.slide-up-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(12px);
}
</style>
